import * as React from 'react';
import styled from 'styled-components';

interface ISpanProps {
    text: string;
}

const SpanContainer = styled('span')(({ theme }) => ({
    [theme.breakpoints.down('lg')]: {
        display: 'none',
    },
}));

const Span = (props: ISpanProps) => <SpanContainer>{props.text}</SpanContainer>;

export default Span;
